import React from 'react';
import {
  BodyTextContainer,
  Button,
  ButtonContainer,
  Cell,
  Container,
  HeaderRow,
  Table,
  TitleTxt,
  TopBar,
} from './PartsStyles';

export default function Parts() {
  const rows = 7;
  const cols = 6;

  const tableHeader = [
    'Parts Name',
    'Type',
    'Description',
    'Components',
    'New/Existing',
    'Length (Base Pair)',
  ]

  const tableData = [
    [
      'BBa_K4751000',
      'Vector Plasmid',
      'pUC118',
      'LacZa, AmpR',
      'New',
      '3162'
    ],
    [
      'BBa_K4751001',
      'Composite',
      'Butyrate Sensing System ',
      'pPchA-PchA-PLEE1',
      'New',
      '747',
    ],
    [
      'BBa_K4751002',
      'CDS',
      'BE2',
      'NA',
      'New',
      '5103',
    ],
    [
      'BBa_K4751003',
      'Composite',
      'Memory Butyrate Sensing System',
      'pPchA-PchA-PLEE1-sgRNA3',
      'New',
      '881'
    ],
    [
      'BBa_K4751004',
      'CDS',
      'sgRNA1',
      'NA',
      'New',
      '96',
    ],
    [
      'BBa_K4751005',
      'CDS',
      'sgRNA3',
      'NA',
      'New',
      '96',
    ],
    [
      'BBa_K4751006',
      'Plasmid Backbone',
      'Recording Plasmid R1',
      'EGFP, AmpR',
      'New',
      '4004',
    ],
    [
      'BBa_K4751007',
      'Composite',
      'sYFP Butyrate Sensing System ',
      'pPchA-PchA-PLEE1-sYFP',
      'New',
      '1506',
    ],
    [
      'BBa_K4751008',
      'Composite',
      '4-HPA sensing system -Be2-sgRNA1',
      'J23101-HpaX-HpaA-pBC-Be2-sgRNA1',
      'New',
      '7811',
    ],
    [
      'BBa_K4751009',
      'Regulator',
      'pPchA',
      'NA',
      'New',
      '101',
    ],
    [
      'BBa_K4751010',
      'CDS',
      'PchA',
      'NA',
      'New',
      '315',
    ],
    [
      'BBa_K4751011',
      'Regulator',
      'pLEE1',
      'NA',
      'New',
      '317',
    ],
    [
      'BBa_K4751012',
      'Composite',
      'Indole Sensing ',
      'PP_RS00430-TrpI-PP_RS00425',
      'New',
      '1225',
    ],
    [
      'BBa_K4751013',
      'Composite',
      'H2O2 Sensing',
      'J23116-OxyR-pTrxC',
      'New',
      '1155',
    ],
    [
      'BBa_K4751014',
      'Composite',
      'Tetrahydrofolate Sensing System ',
      'J23101-THR-TetR-TetA',
      'New',
      '1767',
    ],
    [
      'BBa_K4751015',
      'Composite',
      'Memory Indole Sensing System',
      ' PP_RS00430-TrpI-PP_RS00425-sgRNA3',
      'New',
      '1359',
    ],
    [
      'BBa_K4751016',
      'Composite',
      'Memory H2O2 Sensing System ',
      'J23116-OxyR-pTrxC-sgRNA3',
      'New',
      '1289',
    ],
    [
      'BBa_K4751017',
      'Composite',
      'Memory Tetrahydrofolate Sensing System ',
      'J23101-THR-TetR-pTetA-sgRNA3',
      'New',
      '1901',
    ],
    [
      'BBa_K4751018',
      'Composite',
      'Memory Tetrathionate Sensing System ',
      'NA',
      'New',
      '2732',
    ],
    [
      'BBa_K4751019',
      'CDS',
      'trpI',
      'NA',
      'New',
      '113',
    ],
    [
      'BBa_K4751020',
      'Regulator',
      'promoter PP_RS00430',
      'NA',
      'New',
      '891',
    ],
    [
      'BBa_K4751021',
      'Regulator',
      'promoter PP_RS00425',
      'NA',
      'New',
      '117',
    ],
    [
      'BBa_K4751022',
      'Other',
      'THF Riboswitch (THR)',
      'NA',
      'New',
      '243',
    ],
    [
      'BBa_K4751023',
      'CDS',
      'TetR',
      'NA',
      'New',
      '1550',
    ],
    [
      'BBa_K4751024',
      'Regulator',
      'tetA promoter (pTetA)',
      'NA',
      'New',
      '78',
    ],
    [
      'BBa_K4751026',
      'Composite',
      'Tetrathionate Sensing System',
      'J23116-ttrR-trS-pttrB',
      'New',
      '2598',
    ],
    [
      'BBa_K864100',
      'CDS',
      'sYFP',
      'NA',
      'Existing',
      '723',
    ],
    [
      'BBa_K2560010',
      'RBS',
      'Phytobrick version of BBa_B0032',
      'NA',
      'Existing',
      '22',
    ],
    [
      'BBa_K2560034',
      'Terminator',
      'Phytobrick version of BBa_B0010',
      'NA',
      'Existing',
      '80',
    ],
    [
      'BBa_J23101',
      'Regulator',
      'J23101',
      'NA',
      'Existing',
      '35',
    ],
    [
      'BBa_J23116',
      'Regulator',
      'J23116',
      'NA',
      'Existing',
      '35',
    ],
    [
      'BBa_K1104200',
      'CDS',
      'OxyR',
      'NA',
      '918Existing',
      '',
    ],
    [
      'BBa_K1104201',
      'Regulator',
      'pTrxC',
      'NA',
      'Existing',
      '100',
    ],
    [
      'BBa_K895003',
      'Composite',
      'ttrRS two component system',
      'ttrR-trS-pttrB',
      'Existing',
      '2555',
    ],
  ];

  return (
    <div
      style={{
        height: '80dvh',
      }}
    >
      <Container>
        <div>
          <TopBar src='https://static.igem.wiki/teams/4751/wiki/mgemlogo.png' />
          <TitleTxt>Parts</TitleTxt>
        </div>
        <BodyTextContainer>
          <Table>
            <thead>
              <HeaderRow>
                {Array.from({ length: cols }, (_, i) => (
                  <Cell key={i}>{tableHeader[i]}</Cell>
                ))}
              </HeaderRow>
            </thead>
            <tbody>
              {tableData.map((rows, i) => (
                <tr key={i}>
                  {rows.map((cell, j) => (
                    <Cell key={j}>{cell}</Cell>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </BodyTextContainer>
      </Container>
    </div>
  );
}
